import useTheme from 'hooks/useTheme'
import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = (props) => {
  const { theme } = useTheme()
  return (
    <Svg width="13" height="14" viewBox="0 0 15 14" style={{fill: 'none'}} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9 13L14 7L9 1" stroke="#494949" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 13L6 7L1 1" stroke="#494949" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  )
}

export default Icon
